module.exports = vendor_library;


//////////////////
// WEBPACK FOOTER
// external "vendor_library"
// module id = 23
// module chunks = 4